<ng-template
  #dialerCallLogsCellRendererTmpl
  let-record="record"
  let-column="column"
  let-showRequestFn="showRequestFn"
  let-tableComponent="tableComponent"
>
  <ng-container [ngSwitch]="column.template || column.name">
    <td *ngSwitchCase="'seqid'">
      <a href="javascript:false;" (click)="tableComponent.showSequence(record)"  [attr.title]="record[column.name]">
        {{ record[column.name] }}
      </a>
    </td>
    <td *ngSwitchCase="'pointid'">
      <a href="javascript:false;" (click)="tableComponent.showPoint(record)">
        {{ record[column.name] }}
      </a>
    </td>
    <td *ngSwitchCase="'testpointid'">
      <a href="javascript:false;" (click)="tableComponent.showTestPoint(record)" [attr.title]="record[column.name]">
        {{ record[column.name]|shorten:15:'...' }}
      </a>
    </td>
    <td *ngSwitchCase="'phonemac'">
      <a href="javascript:false;" (click)="tableComponent.showHandset(record)">
        {{ record[column.name] }}
      </a>
    </td>
    <td
      fes-table-view-default-cell-renderer
      *ngSwitchDefault
      [column]="column"
      [record]="record"
      [tableComponent]="tableComponent"
    ></td>
  </ng-container>
</ng-template>

<app-dialer-call-logs-table
  [cellRendererTmplRef]="dialerCallLogsCellRendererTmpl"
  [tabConfig]="tabConfig"
  [detailFn]="detailFn"
  [isActiveView]="tabConfig.active"
  [contextJson]="tabConfig.viewInfo.id"
  (contextJsonChange)="contextJsonChangeHandler($event, tabConfig)"
>
</app-dialer-call-logs-table>
